import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { EventTypes } from 'src/app/core/constants/event-types';
import { maxNumberValidator } from 'src/app/core/validators/max-number-validator';
import { minNumberValidator } from 'src/app/core/validators/min-number-validator';
import { UpdateGroupPriceCommand } from '../../../../core/api/models/update-group-price-command';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { CreateGroupPriceCommand } from './../../../../core/api/models/create-group-price-command';
import { GroupPriceDto } from './../../../../core/api/models/group-price-dto';
import { GroupPricesService } from './../../../../core/api/services/group-prices.service';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-group-price-form',
    templateUrl: './group-price-form.component.html',
    styleUrls: ['./group-price-form.component.scss'],
    imports: [BaseFormModule]
})
export class GroupPriceFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  pageVocabs = 'pages.groupPrice.form.';

  formPageConfig: FormPageConfig<GroupPriceDto> = {};
  protected currentService = inject(GroupPricesService);
  model: CreateGroupPriceCommand = {};
  @Input() isSuperAdmin;
  @Input() categoryId = 1;

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.model.categoryId = this.categoryId;
    this.changeIsPercentageBenefitForInternational();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      minPrice: new FormControl('', [
        Validators.required,
        maxNumberValidator(+this.model.maxPrice),
      ]),
      maxPrice: new FormControl('', [
        Validators.required,
        minNumberValidator(+this.model.minPrice),
      ]),
      description: new FormControl(''),
      mtnSmartPercent: new FormControl('', [
        Validators.required,
        Validators.min(0),
        // Validators.pattern(RegularExpressions.floatNumbers),
      ]),
      mciSmartPercent: new FormControl('', [
        Validators.required,
        Validators.min(0),
        // Validators.pattern(RegularExpressions.floatNumbers),
      ]),
      rightelSmartPercent: new FormControl('', [
        Validators.required,
        Validators.min(0),
        // Validators.pattern(RegularExpressions.floatNumbers),
      ]),
      internationalBenefitValue: new FormControl('', [
        Validators.required,
        Validators.min(0),
        // Validators.pattern(RegularExpressions.floatNumbers),
      ]),
      isDefault: new FormControl(''),
      isPercentageBenefitForInternational: new FormControl(''),
      categoryId: new FormControl(''),
    });
  }

  changeIsPercentageBenefitForInternational() {
    this.form.get('internationalBenefitValue').clearValidators();
    if (this.model.isPercentageBenefitForInternational)
      this.form.get('internationalBenefitValue').setValidators([
        Validators.required,
        Validators.min(0),
        // Validators.pattern(RegularExpressions.floatNumbers),
      ]);
    else
      this.form
        .get('internationalBenefitValue')
        .setValidators([Validators.required]);
  }

  onChangeMinMaxPrice() {
    this.form.get('minPrice').clearValidators();
    this.form.get('maxPrice').clearValidators();

    if (!isNaN(this.model.maxPrice))
      this.form
        .get('minPrice')
        .setValidators([
          Validators.required,
          maxNumberValidator(this.model.maxPrice),
        ]);
    if (!isNaN(this.model.minPrice))
      this.form
        .get('maxPrice')
        .setValidators([
          Validators.required,
          minNumberValidator(this.model.minPrice),
        ]);

    this.form.get('minPrice').updateValueAndValidity();
    this.form.get('maxPrice').updateValueAndValidity();
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateGroupPriceCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .groupPricesCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateGroupPriceCommand) {
    this.unSubs();

    this.loading = true;

    model.id = this.formPageConfig.editId;

    this.currentService
      .groupPricesUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    try {
      this.model.mtnSmartPercent = Number(this.model.mtnSmartPercent);
      this.model.mciSmartPercent = Number(this.model.mciSmartPercent);
      this.model.rightelSmartPercent = Number(this.model.rightelSmartPercent);
      this.model.internationalBenefitValue = Number(
        this.model.internationalBenefitValue
      );
      super.onSubmit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

}
